import "core-js/modules/es.array.push.js";
import { structureList, delStructure, structureStatus, structureResource } from './request';
import companyModel from './companyModel.vue';
import DeactivateModel from './deactivateModel.vue';
export default {
  components: {
    companyModel,
    DeactivateModel
  },
  data() {
    return {
      companyShow: false,
      deactivateShow: false,
      form: {
        structureId: undefined
      },
      resourceList: [],
      data: [],
      columns: [{
        dataIndex: 'name',
        key: 'name',
        slots: {
          title: '名称'
        },
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        slots: {
          title: '架构图'
        },
        align: 'center',
        key: 'age',
        scopedSlots: {
          customRender: 'framework'
        },
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        key: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 300
      }]
    };
  },
  created() {
    structureResource({}).then(res2 => {
      this.resourceList = res2;
    });
    this.getDataFun();
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      structureList(this.form).then(res => {
        console.log(res);
        this.data = res;
      });
    },
    addDepartment(data, type) {
      this.companyShow = true;
      this.$nextTick(() => {
        this.$refs.companyForm.init(data, type);
      });
    },
    delDepartment(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该架构') + '？', {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        delStructure({
          structureId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handleDeactivate(val, type) {
      this.deactivateShow = true;
      this.$nextTick(() => {
        this.$refs.deactivateForm.init(val, type);
      });
    },
    handleEnable(val) {
      structureStatus({
        structureId: val.id,
        status: 1
      }).then(() => {
        this.$message.success(this.$t('操作成功'));
        this.getDataFun();
      });
    },
    goFrameworkFun(record) {
      if (!this.isAuth('customer.companyStructureBranch')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      this.$router.push({
        name: 'frameworkCustomer',
        params: {
          id: record.id
        }
      });
    }
  }
};